// Static data for imprint type selection (Text, Image, Text & Image)

export const IMPRINT_TYPES = [
  {
    id: 1,
    value: 'text',
    label: 'Text Only',
    description: 'Add text lines with custom colors for your imprint',
    maxLines: 5
  },
  {
    id: 2,
    value: 'image',
    label: 'Image Only',
    description: 'Upload your artwork or logo',
    maxLines: 0
  },
  {
    id: 3,
    value: 'text_and_image',
    label: 'Text & Image',
    description: 'Combine text and images for your imprint',
    maxLines: 5
  }
];

// Get imprint type by ID
export const getImprintTypeById = (id) => {
  return IMPRINT_TYPES.find(type => type.id === id) || IMPRINT_TYPES[0];
};

// Get imprint type by value
export const getImprintTypeByValue = (value) => {
  return IMPRINT_TYPES.find(type => type.value === value) || IMPRINT_TYPES[0];
};
